module.exports = {
  DEFAULT_EMAIL_LIST: 'at_daily',
  EMAIL_PAGES: [
    {
      key: 'at_spring_cleaning_drip_program',
      name: 'Apartment Therapy Spring Cleaning',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/at%2Fhouse%20tours%2F2019-12%2FJulia%20G%2F_E5A0139',
      metadata: {
        title: 'Spring Cleaning is Easier Than Ever!',
        description: `Sign up now for Apartment Therapy’s (free!) 10-day spring cleaning program. We’ll tell you what to clean and when (and how to do it all) so you get your spring cleaning done in record time.`,
        ogTitle: `Spring Cleaning is Easier Than Ever!`,
        ogDescription: `Sign up now for Apartment Therapy’s (free!) 10-day spring cleaning program. We’ll tell you what to clean and when (and how to do it all) so you get your spring cleaning done in record time.`,
        ogImage:
          'https://cdn.apartmenttherapy.info/image/upload/at%2Fhouse%20tours%2F2019-12%2FJulia%20G%2F_E5A0139',
        socialTitle: 'Spring Cleaning is Easier Than Ever!',
        socialDescription: `Sign up now for Apartment Therapy’s (free!) 10-day spring cleaning program. We’ll tell you what to clean and when (and how to do it all) so you get your spring cleaning done in record time.`,
        socialImage:
          'https://cdn.apartmenttherapy.info/image/upload/at%2Fhouse%20tours%2F2019-12%2FJulia%20G%2F_E5A0139'
      },
      href: '/email/show?key=at_spring_cleaning_drip_program',
      as: '/email/spring-cleaning'
    },
    {
      key: 'at_daily',
      name: 'Apartment Therapy Daily',
      image:
        'https://s3.amazonaws.com/pixtruder/original_images/b38e3edd1471cb1de0a009e959e31857b43f2c7c',
      metadata: {
        title: 'Apartment Therapy Daily Email Signup',
        description: `Sign up for Apartment Therapy's Daily email newsletter to receive our favorite posts, tours, products, and shopping guides in your inbox.`,
        ogTitle: `Sign Up for Apartment Therapy's Daily Email Newsletter`,
        ogDescription: `Sign up for Apartment Therapy's Daily email newsletter to receive our favorite posts, tours, products, and shopping guides in your inbox.`,
        ogImage:
          'https://s3.amazonaws.com/pixtruder/original_images/b27c3c4c25f0038644ed1615071b00d52bf2025f',
        socialTitle: 'Apartment Therapy Daily Email Signup',
        socialDescription: `Sign up for Apartment Therapy's Daily email newsletter to receive our favorite posts, tours, products, and shopping guides in your inbox.`,
        socialImage:
          'https://s3.amazonaws.com/pixtruder/original_images/b27c3c4c25f0038644ed1615071b00d52bf2025f'
      }
    },
    {
      key: 'at_real_estate',
      name: 'Real Estate',
      image:
        'https://s3.amazonaws.com/pixtruder/original_images/71990dda1c0c0b79ecdba6b3371452390ec96c0a',
      href: '/email/show?key=at_real_estate',
      as: '/email/real-estate'
    },
    {
      key: 'at_retail_therapy',
      name: 'Retail Therapy',
      image:
        'https://s3.amazonaws.com/pixtruder/original_images/653837fc6b0e98a9f77829a613877fb581615db2',
      href: '/email/show?key=at_retail_therapy',
      as: '/email/marketplace'
    },
    {
      key: 'at_jan_cure_2021',
      name: 'Apartment Therapy 2021 January Cure',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/v1554155678/at/house%20tours%20stock%20archive/3dfc6f3c4d488cb37d44d131e8626a363648e7a4',
      href: '/email/show?key=at_jan_cure_2021',
      as: '/email/january-cure',
      metadata: {
        title: 'The January Cure Is Back and Better than Ever!',
        description: `Sign up now (it's free!) to clean, organize, and prepare your home for the new year in just 20 days. The Cure is back, in partnership with Libman.`
      }
    },
    {
      key: 'at_small_cool_event_announcements_2020',
      name: 'Apartment Therapy Small/Cool 2020',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/v1580754520/small%20cool/Logos/SmallCool_Simple_3290x2194.png',
      href: '/email/show?key=at_small_cool_event_announcements_2020',
      as: '/email/small-cool-event',
      metadata: {
        title:
          'Apartment Therapy Small/Cool 2020 Experience: April 4 & 5 in NYC',
        description: `Sign up to attend & get updates on Apartment Therapy's first ever shoppable home design event. It’s all happening April 4&5 at Industry City, home to the Brooklyn Design District.`
      }
    },
    {
      key: 'at_smallcool_experience_2021',
      name: 'Apartment Therapy Small/Cool Experience 2021',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/v1618407825/at/small-cool/2021/Experience/Site%20Assets/Email%20Stand%20Alone%20Image/SC_standalone_email_image.png',
      href: '/email/show?key=at_smallcool_experience_2021',
      as: '/email/small-cool-experience',
      metadata: {
        title: 'Get Ready for the 2021 Small/Cool Experience',
        description:
          'Small Spaces. Cool Designs. Big Ideas. The Small/Cool Experience is back for 2021! Sign up to get exclusive updates on the designers, trends, games, and more.'
      }
    },
    {
      key: 'at_editor_letter',
      name: 'At Home with Laura',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/v1556038533/at/house%20tours/archive/EmilyKim/33f91dcafb980a58aa7e0783e591f049fc6bfbfa.jpg',
      href: '/email/show?key=at_editor_letter',
      as: '/email/at-home-with-laura',
      metadata: {
        title: 'At Home with Laura',
        description: `Our editor in chief shares her best tips, inspiring stories, and thoughtful guides—straight from her own apartment.`
      }
    },
    {
      key: 'at_decluttering_cure',
      name: 'Apartment Therapy Decluttering Cure',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/v1567842905/at/archive/e75adfda2bb50800aa20e1e0846b060254c1267e.jpg',
      href: '/email/show?key=at_decluttering_cure',
      as: '/email/decluttering-cure',
      metadata: {
        title: 'Get Your Home In Order With Our Decluttering Cure',
        description:
          'Join our free 20-day decluttering class and enjoy a more efficient, more organized, and more streamlined space, in partnership with Libman.'
      }
    },
    {
      key: 'cb_weekly',
      name: 'Meet Cubby. Real solutions for unreal times.',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/f_auto,q_auto/v1556033413/at/house%20tours/archive/Danika/ac6b6093e73d82eab41a6376b16ac3f2d1813230.jpg',
      href: '/email/show?key=cb_weekly',
      as: '/email/cubby-real-solutions-for-unreal-times',
      metadata: {
        title: 'Meet Cubby. Real solutions for unreal times.',
        description:
          'Join us for a weekly dose of fresh, modern ideas for life at home with your kids.'
      }
    },
    {
      key: 'at_holiday_cure',
      name: 'Apartment Therapy Holiday Cure',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/f_auto,q_auto:eco/v1567620488/at/archive/8bcc17a9c93e93cab9a888d34d2ac08682411f77.jpg',
      href: '/email/show?key=at_holiday_cure',
      as: '/email/holiday-cure',
      metadata: {
        title: 'Get a Cozier, Cleaner Home with Our Holiday Cure',
        description:
          'Join our free 20-day holiday guide to creating a comfortable, calm and clean space during this holiday season, in partnership with Libman.'
      }
    },
    {
      key: 'at_home_ec_2021',
      name: 'Apartment Therapy Home Economics',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/f_auto,q_auto:eco/v1554150566/at/house%20tours%20stock%20archive/948fc2970e1445089cacd74b3f041dfe2705d0f0.jpg',
      href: '/email/show?key=at_home_ec_2021',
      as: '/email/home-economics',
      metadata: {
        title: 'Get Ready to Become a Homeowner with Home Economics',
        description:
          'Sign up for Home Economics, a fun (and free!) six-week lesson on homebuying for beginners, in partnership with Lower.'
      }
    },
    {
      key: 'at_spring_cleaning_2021',
      name: 'Apartment Thearpy Spring Cleaning Cure',
      image:
        'https://cdn.apartmenttherapy.info/image/upload/v1554336660/project%20prism/color%20search%20archive/540102d9097cd6b0bb14faa2dabd4f55a39faa0e.jpg',
      href: '/email/show?key=at_spring_cleaning_2021',
      as: '/email/spring-cleaning-cure',
      metadata: {
        title: 'Join the Spring Cleaning Cure for the Deepest Clean Ever!',
        description:
          'Join us for our 20-day free program to get the knowledge and motivation to deep clean your home this spring, in partnership with Libman.'
      }
    }
  ],
  FEATURED_MAILING_LIST_COUNT: 2,
  FEATURED_MAILING_LIST_IMAGES: {
    at_decluttering_cure:
      'https://cdn.apartmenttherapy.info/image/upload/v1596825529/email/Mailing%20Lists/DeclutteringCure_Email.png',
    at_january_cure_2020:
      'https://cdn.apartmenttherapy.info/image/upload/v1576609709/at/art/design/2019-12/january-cure-2020/Jan-Cure-2020-featured-list-image.png',
    at_spring_cleaning_drip_program:
      'https://cdn.apartmenttherapy.info/image/upload/v1583780503/at/art/design/2020-03/spring-cleaning-2020/spring-cleaning-email-at.jpg',
    at_editor_letter:
      'https://cdn.apartmenttherapy.info/image/upload/v1591046125/email/Mailing%20Lists/AT-Ed-Letter-newsletter600x414.png',
    at_small_cool_event_announcements_2020:
      'https://cdn.apartmenttherapy.info/image/upload/v1579878342/email/Mailing%20Lists/small-cool-logo-alone.png',
    at_retail_therapy:
      'https://cdn.apartmenttherapy.info/image/upload/v1580314718/email/Mailing%20Lists/retail-therapy-mailing.png',
    at_daily:
      'https://cdn.apartmenttherapy.info/image/upload/v1576619198/email/Mailing%20Lists/at_daily_featured_list_image_border.png',
    cb_weekly:
      'https://cdn.apartmenttherapy.info/image/upload/c_fill,g_center,h_320,w_480/v1600092856/email/Mailing%20Lists/Cubby_logo_email.jpg'
  },
  MAILING_LIST_PAGE_COPY: `Get our best inspiration & advice for your home. Select the emails you'd like to receive from below and click "Subscribe".`,
  NEWSLETTER_METADATA: {
    title: 'Apartment Therapy Newsletter & Email Signup',
    description:
      "Keep up with Apartment Therapy's best daily tips and be the first to know about our special programs and promos with our free newsletters emailed to your inbox.",
    ogTitle:
      'Get All The Best From Apartment Therapy Delivered Straight to Your Inbox',
    ogDescription:
      'Our free daily and weekly newsletters have all our best tips, tricks, and inspiration for your home.',
    ogImage:
      'https://cdn.apartmenttherapy.info/image/upload/v1556041642/at/house%20tours/archive/Jennifer%20MacFarlane/0309b0b8d7cfe6fd5cfaf66743d556e283a50cf9.jpg',
    ogUrl: 'https://www.apartmenttherapy.com/mailing-list',
    canonical: 'https://www.apartmenttherapy.com/mailing-list'
  },
  EMAIL_LEGAL: {
    at_smallcool_experience_2021: {
      text: `By entering my email above and clicking Sign Up,  I agree to receive information, newsletters, promotional materials and special offers via email from Apartment Therapy Media and/or any of the Small/Cool Experience sponsors, including: Behr Paint Company, LUMAS, Interior Define, Overstock, and Tuft & Needle. I understand that I can withdraw my consent at any time on the individual sponsors' sites. Subject to sponsors' privacy policies as listed below.`,
      links: [
        {
          href: '/page?path=/about/privacy-policy',
          as: '/about/privacy-policy',
          label: 'Apartment Therapy Media Privacy Policy'
        },
        {
          href: 'https://www.behr.com/consumer/privacy-policy',
          label: 'Behr Privacy Policy'
        },
        {
          href: 'https://www.lumas.com/privacy-policy/',
          label: 'LUMAS'
        },
        {
          href: 'https://www.interiordefine.com/privacy-policy',
          label: 'Interior Define Privacy Policy'
        },
        {
          href:
            'https://help.overstock.com/help/s/article/PRIVACY-AND-SECURITY-POLICY',
          label: 'Overstock Privacy Policy'
        },
        {
          href: 'https://www.tuftandneedle.com/legal/privacy/',
          label: 'Tuft & Needle Privacy Policy'
        }
      ]
    }
  }
};
